import { useContext } from 'react';

import type { To } from 'react-router-dom';

import { RouterContext } from '../contexts/routerExports';

// Define NavigateOptions interface based on react-router-dom's expected structure
interface NavigateOptions {
  replace?: boolean;
  state?: any;
  preventScrollReset?: boolean;
  relative?: 'route' | 'path';
}

// Añadir una declaración global para TypeScript
declare global {
  interface Window {
    __pendingNavigations?: Array<[To, NavigateOptions | undefined]>;
  }
}

export const useRouterContext = () => {
  const context = useContext(RouterContext);
  if (!context) {
    // En lugar de lanzar un error, devolvemos un objeto con funciones seguras
    return {
      navigate: (to: To, options?: NavigateOptions) => {
        console.warn(
          'RouterContext no está disponible. La navegación se realizará cuando el contexto esté listo.'
        );
        // Almacenamos los argumentos para navegar cuando el contexto esté disponible
        const pendingNavigations = window.__pendingNavigations || [];
        pendingNavigations.push([to, options]);
        window.__pendingNavigations = pendingNavigations;

        // Intentamos procesar las navegaciones pendientes en el siguiente ciclo
        setTimeout(() => {
          const router = document.querySelector('[data-router-initialized="true"]');
          if (router && window.__pendingNavigations?.length) {
            window.__pendingNavigations.forEach(navArgs => {
              try {
                // Convertir el valor To a string antes de asignarlo a window.location.href
                window.location.href =
                  typeof navArgs[0] === 'string' ? navArgs[0] : '/' + navArgs[0];
              } catch (error) {
                console.error('Error al intentar navegar:', error);
              }
            });
            window.__pendingNavigations = [];
          }
        }, 100);
      },
      location: {
        pathname: window.location.pathname,
        search: window.location.search,
        hash: window.location.hash,
        state: null,
        key: '',
      },
      params: {},
    };
  }
  return context;
};
